import { render, staticRenderFns } from "./MedicalCertificateRequirementSummary.vue?vue&type=template&id=f4d649b0"
import script from "./MedicalCertificateRequirementSummary.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificateRequirementSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports